import http from "@/utils/request";

const RolePermissionApi = {
  roleBindPermission(data) {
    return http.sendRequest({
      METHOD_NAME: "rolePermission.roleBindPermission",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
};
export default RolePermissionApi;
